import { tick } from "svelte";
import { get, writable } from "svelte/store";
import API from "../../API/API";
import LoadState from "../../Enums/LoadState";
import VisibilityState from "../../Map/Enums/VisibilityState";
import MapStore from "../../Map/Store";
import Image from "../../Models/Image";
import ImageCollection from "../../Models/ImageCollection";

const ImageCollectionsStore = {
	config: {},
	meta: {
		loadState: writable(LoadState.INIT),
		layers: [],
		layerData: {

		},
		visible: writable(false),
		lastUpdated: writable(0)
	},
	filters: {
		filterString: writable("")
	},
	results: {
		imageCollections: writable([])
	},
	actions: {
		reinit: () => {
			ImageCollectionsStore.meta.loadState.set(LoadState.INIT);
			ImageCollectionsStore.meta.lastUpdated.set(Date.now());
			tick().then(() => {
				ImageCollectionsStore.actions.init();
			});
		},
		init: () => {
			if (get(ImageCollectionsStore.meta.loadState) !== LoadState.INIT) {
				return;
			}
			ImageCollectionsStore.meta.loadState.set(LoadState.LOADING);
			console.log("Loading Charts...");

			API.get("image-sets").then((results) => {
				console.log("results", results);
				const imageCollections = [];
				for (let i = 0; i < results.length; i++) {
					const collection = new ImageCollection(results[i]);
					collection.store = ImageCollectionsStore;
					for (let j = 0; j < results[i].images.length; j++) {
						const image = new Image(results[i].images[j]);
						image.collection = collection;

						image.events.onLoaded.add((image) => {
							const map = MapStore.helpers.getMap();
							map.addSource(image.layerId, {
								type: "image",
								url: image.url,
								coordinates: image.coords
							});
							map.addLayer({
								id: image.layerId,
								source: image.layerId,
								type: "raster",
								paint: {
									"raster-opacity": 1.0,
									"raster-resampling": "nearest"
								},
								layout: {
									visibility: VisibilityState.VISIBLE
								}
							}, "hillshade");

							ImageCollectionsStore.meta.lastUpdated.set(Date.now());
						});
						collection.images.push(image);
					}
					imageCollections.push(collection);
				}

				ImageCollectionsStore.results.imageCollections.set(imageCollections);

				ImageCollectionsStore.meta.loadState.set(LoadState.LOADED);
				ImageCollectionsStore.meta.lastUpdated.set(Date.now());
			});
		},

		loadSingle: (imageModelObject) => {
			console.log("loading...");
			API.get("images/meta/" + imageModelObject.id)
				.then((response) => {
					console.log("response", response);
					imageModelObject.setData(response);
					imageModelObject.loaded = true;
					imageModelObject.events.onLoaded.dispatch(imageModelObject);
					ImageCollectionsStore.meta.lastUpdated.set(Date.now());
				})
				.catch((e) => {
					console.error(e);
					// this.visible.set(false);
				});
		},
		opacityUpdated: (imageObject) => {
			const map = MapStore.helpers.getMap();
			map.setPaintProperty(imageObject.layerId, "raster-opacity", get(imageObject.opacity));
			ImageCollectionsStore.meta.lastUpdated.set(Date.now());
		},
		toggle: (e, imageObject) => {
			const wasVisible = get(imageObject.visible);
			const newVisible = !wasVisible;
			imageObject.visible.set(newVisible);

			const map = MapStore.helpers.getMap();
			if (newVisible) {
				if (!imageObject.loaded) {
					imageObject.collection.store.actions.loadSingle(imageObject);
				}
				else {
					map.setLayoutProperty(imageObject.layerId, "visibility", VisibilityState.VISIBLE);
				}
			}
			else if (!newVisible && imageObject.loaded) {
				map.setLayoutProperty(imageObject.layerId, "visibility", VisibilityState.NONE);
			}

			ImageCollectionsStore.meta.lastUpdated.set(Date.now());
		}
	},
	helpers: {

	}
};

export default ImageCollectionsStore;
